import React, { useContext } from 'react';
import { default as Form } from 'components/connectedForm';
import * as input from 'components/connectedForm/inputComponents';
import generateTimeOptions from 'utils/TimeUtil';
import AppContext from '../../components/Context/AppContext';

export default () => {
  const { fullUserDetails } = useContext(AppContext);

  return (
    <>
      <Form.Row>
        <Form.Fieldset cols={6 / 8}>
          <Form.Legend label="Instruction Lines" />
          <Form.Field
            dataid="deliveryInstruction.instructionLines"
            component={input.BlurTextField}
            includeLabel={false}
            type={'textarea'}
          />
        </Form.Fieldset>
      </Form.Row>
      <Form.Row>
        <Form.Fieldset cols={3 / 8}>
          <Form.Legend label="Options" />
          <Form.Field
            dataid="deliveryInstruction.deliveriesBookedIn"
            component={input.Checkbox}
            label="Deliveries to be booked-in?"
            labelCols={2 / 5}
            inputCols={3 / 5}
          />
          <Form.Field
            dataid="deliveryInstruction.noArticulatedVehicles"
            component={input.Checkbox}
            label="Not suitable for articulated vehicles?"
            labelCols={2 / 5}
            inputCols={3 / 5}
          />
          <Form.Field
            dataid={'deliveryInstruction.start'}
            component={input.Dropdown}
            label="Start Time"
            options={generateTimeOptions()}
            valueKey="time"
            labelKey="time"
            valueOnly={true}
            clearable={true}
            rawLabel
          />
          <Form.Field
            dataid={'deliveryInstruction.cutOff'}
            component={input.Dropdown}
            label="Cut Off Time"
            options={generateTimeOptions()}
            valueKey="time"
            labelKey="time"
            valueOnly={true}
            clearable={true}
            rawLabel
          />
          <Form.Field
            dataid="deliveryInstruction.dropNumber"
            component={input.BlurTextField}
            label="Drop Number"
            decimals={0}
          />
          <Form.Field dataid="deliveryInstruction.entryCode" component={input.BlurTextField} label="Entry Code" />
        </Form.Fieldset>
        <Form.Fieldset cols={2 / 8}>
          <Form.Legend label="No Deliveries on these Days" />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesMonday"
            component={input.Checkbox}
            label="Monday"
            temporary
          />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesTuesday"
            component={input.Checkbox}
            label="Tuesday"
            temporary
          />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesWednesday"
            component={input.Checkbox}
            label="Wednesday"
            temporary
          />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesThursday"
            component={input.Checkbox}
            label="Thursday"
            temporary
          />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesFriday"
            component={input.Checkbox}
            label="Friday"
            temporary
          />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesSaturday"
            component={input.Checkbox}
            label="Saturday"
            temporary
          />
          <Form.Field
            dataid="deliveryInstruction.noDeliveriesSunday"
            component={input.Checkbox}
            label="Sunday"
            temporary
          />
          {fullUserDetails?.flags?.deliveryRoutesEnabled ? (
            <Form.Field dataid="deliveryInstruction.timeRestriction" component={input.Dropdown} label="Restriction" />
          ) : null}
        </Form.Fieldset>
        {fullUserDetails?.flags?.maxoptraEnabled ? (
          <Form.Fieldset cols={3 / 8}>
            <Form.Legend label="Maxoptra" />
            <Form.Field
              dataid="deliveryInstruction.vehicleRequirements"
              component={input.DisplayListSimple}
              label="Vehicle Requirements (Short Reference)"
            />
            <Form.Field
              component={input.BlurTextField}
              dataid="maxoptraDropDurationMinutes"
              label="MaxOptra Drop Duration (Minutes)"
              decimals={0}
              hint="How long drops take to complete. If set to zero, the value configured in the MaxOptra portal will be used"
            />
            <Form.Field dataid="maxoptraOrderPriority" component={input.Dropdown} label="Maxoptra Order Priority" />
          </Form.Fieldset>
        ) : null}
      </Form.Row>
    </>
  );
};
